import { buildFiltersState } from './state';
import getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';

export default (placeholders) => ({
  namespaced: true,
  state: buildFiltersState(placeholders),
  getters,
  mutations,
  actions,
});
